export const EXTENSION_NAME = 'Unite';
export const STORE_KEY = 'unite_store';

export const xHeaders = {
    'secure-tokens': 'X-Secure-Tokens',
    'trace-id': 'X-Trace-Id',
} as const;

export const defaultPagination = {
    page: 0,
    perPage: 15,
};

export const defaultPaginationPerPageOptions = ['5', '10', '15', '20', '50', '100'];
